// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Nav from 'react-bootstrap/Nav';
import Select from 'react-select'
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { MachinesFetchAPI } from '../../api/Machines';
import { PaymentMethodFetchAPI } from '../../api/PaymentMethod';
import { CategoriesDashFetchAPI } from '../../api/CategoriesDash';
import { WarehouseFetchAPI } from '../../api/Warehouse';
import { GroupsFechtAPI } from '../../api/Groups';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import { useSelectedBranch } from '../../../context/BranchContext';
import ModalselectList from './ModalWarehouse/ModalselectList';
import NavBar from '../NavBar/Navbar';
import Table from '../Table/Table';
import InAndExit from './InAndExit';
import Transfer from './Transfer';
import Reception from './Reception';
import Warehouse from './Warehouse';
import Report from './Report';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .inv-
───────────────────────────────────────────────────────── */
const INV_CSS = `
@keyframes inv-up   { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
@keyframes inv-fade { from{opacity:0} to{opacity:1} }

/* ── page ── */
.inv-page {
  min-height: 100vh;
  background: var(--bg-3, #F8F8F8);
  padding-bottom: 4rem;
}

/* ── banner ── */
.inv-banner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 1rem;
  background: var(--bg, #fff);
  border-bottom: 1.5px solid var(--border, rgba(0,0,0,.07));
  padding: 1.1rem clamp(1rem,4vw,2rem);
  box-shadow: 0 2px 8px rgba(0,0,0,.04);
  animation: inv-up .3s ease both;
}
.inv-banner-left {}
.inv-banner-eyebrow {
  font-size: .67rem; font-weight: 700; letter-spacing: .09em; text-transform: uppercase;
  color: #1B3A6B; margin-bottom: .2rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.inv-banner-title {
  font-size: 1.12rem; font-weight: 800; color: var(--text, #0A0A0A);
  font-family: var(--font-sans,-apple-system,sans-serif); letter-spacing: -.02em;
  display: flex; align-items: center; gap: .5rem;
}
.inv-banner-sub {
  font-size: .75rem; color: var(--text-3, #B4B4B4); margin-top: .2rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── tab nav ── */
.inv-nav {
  display: flex; gap: .25rem; flex-wrap: wrap;
  padding: .85rem clamp(1rem,4vw,2rem) 0;
  background: var(--bg, #fff);
  border-bottom: 1.5px solid var(--border, rgba(0,0,0,.07));
  overflow-x: auto; scrollbar-width: none;
}
.inv-nav::-webkit-scrollbar { display: none; }

.inv-nav-item {
  display: inline-flex; align-items: center; gap: .38rem;
  padding: .55rem 1rem;
  border: none; background: transparent;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .8rem; font-weight: 500; color: var(--text-3, #B4B4B4);
  cursor: pointer; white-space: nowrap;
  border-bottom: 2.5px solid transparent;
  margin-bottom: -1.5px;
  transition: color .14s, border-color .14s;
  border-radius: 0;
}
.inv-nav-item:hover { color: #1B3A6B; }
.inv-nav-item.active {
  color: #1B3A6B; font-weight: 700;
  border-bottom-color: #1B3A6B;
}
.inv-nav-item svg { flex-shrink: 0; }

/* ── content ── */
.inv-content {
  padding: 1.5rem clamp(1rem,4vw,2rem);
  animation: inv-fade .22s ease both;
}

/* ── no-branch placeholder ── */
.inv-no-branch {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  min-height: 280px; gap: .85rem;
  background: var(--bg, #fff);
  border: 1.5px dashed var(--border-md, rgba(0,0,0,.13));
  border-radius: 16px; padding: 2rem;
  text-align: center;
  animation: inv-up .3s ease both;
}
.inv-no-branch-icon {
  width: 64px; height: 64px; border-radius: 50%;
  background: rgba(27,58,107,.08); color: #1B3A6B;
  display: grid; place-items: center; font-size: 1.6rem;
}
.inv-no-branch-title {
  font-size: .9rem; font-weight: 700; color: var(--text, #0A0A0A);
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.inv-no-branch-sub {
  font-size: .78rem; color: var(--text-3, #B4B4B4);
  max-width: 260px; line-height: 1.6;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── responsive ── */
@media(max-width: 640px) {
  .inv-banner { flex-direction: column; align-items: flex-start; }
  .inv-nav-item { font-size: .75rem; padding: .48rem .75rem; }
}
`;

/* ── ICONS ── */
const IcoBox = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" /></svg>;
const IcoGraph = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></svg>;
const IcoDownload = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>;
const IcoUpload = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>;
const IcoArrows = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" /><polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" /></svg>;
const IcoDb = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" /><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" /></svg>;

/* ── tab definitions ── */
const TABS = [
    { key: 'reports', label: 'Reportes', icon: <IcoGraph /> },
    { key: 'receive', label: 'Recepción de transferencias', icon: <IcoDownload /> },
    { key: 'send', label: 'Creación de transferencias', icon: <IcoArrows /> },
    { key: 'in', label: 'Recepción inicial', icon: <IcoUpload /> },
    { key: 'out', label: 'Salida de productos', icon: <IcoUpload style={{ transform: 'rotate(180deg)' }} /> },
    { key: 'wherehouse', label: 'Bodegas', icon: <IcoDb /> },
];

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original, nuevo shell visual
════════════════════════════════════════════════════════ */
const Inventory = () => {

    /* inject CSS once */
    useEffect(() => {
        const id = "inv-styles";
        if (!document.getElementById(id)) {
            const el = document.createElement("style");
            el.id = id; el.textContent = INV_CSS;
            document.head.appendChild(el);
        }
    }, []);

    /* ════════════════════════════════════
       LÓGICA ORIGINAL — 100% INTACTA
    ════════════════════════════════════ */
    let { business_code } = useParams();
    let user = JSON.parse(localStorage.getItem('user'));
    let token = localStorage.getItem('x-access-token');

    const { selectedBranch, setSelectedBranch } = useSelectedBranch();

    const [userBranchoffices, setUserBranchs] = useState([]);
    const [eventHandler, setEventHandler] = useState(0);
    const [warehouses, setWarehouses] = useState([]);
    const [ListallWarehouses, setListallWarehouses] = useState([]);
    const [groups, setGroups] = useState([]);
    const [machinesList, setMachinesList] = useState([]);
    const [selectedMachine, setSelectedMachine] = useState(0);
    const [showModalDetails, setShowModalDetails] = useState(false);

    const getBranchoffice = async (code) => {
        try {
            const branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business_code, code);
            setSelectedBranch({ name: branch.data.branchoffice.name, code: branch.data.branchoffice.code, id: branch.data.branchoffice.id });
            getWarehouseByBrachoffice(branch.data.branchoffice.id);
            getGroups(branch.data.branchoffice.id);
            setEventHandler(1);
        } catch (err) {
            setSelectedBranch({ code: 0, id: 0 });
            setEventHandler(eventHandler + 1);
        }
    };

    const getGroups = async (branchoffice_id) => {
        try {
            const response = await GroupsFechtAPI.getGroupsByBranchoffice(branchoffice_id, token);
            let groupInfo = [];
            response.data.data.forEach(group => { groupInfo.push({ value: JSON.stringify(group), label: group.name }); });
            setGroups(response.data.data);
            setEventHandler(1);
        } catch (err) {
            console.log(err); setGroups([]);
        }
    };

    const branchList = () => userBranchoffices.map(branch => (
        <option key={branch.code} value={branch.code}>{branch.branchoffice_name}</option>
    ));

    const getWarehouseByBrachoffice = async (branchoffice_id) => {
        try {
            const response = await WarehouseFetchAPI.getwarehousebybracnhoffice(branchoffice_id, 0, token);
            let filteredWarehouses = response.data.warehouses.filter(w => w.is_enable == 1);
            console.log(response.data.warehouses);
            setListallWarehouses(response.data.warehouses);
            setWarehouses(filteredWarehouses);
            setEventHandler(1);
        } catch (err) {
            setWarehouses([]); console.log(err);
        }
    };

    const actionSelectBranch = (branchCode) => {
        getBranchoffice(branchCode);
        if (branchCode == 0) { setWarehouses([]); setGroups([]); setEventHandler(1); }
    };

    useEffect(() => {
        setUserBranchs(user.branchoffices);
        setEventHandler(0);
    }, []);

    useEffect(() => {
        if (selectedBranch.code !== 0) { /* getWarehouseByBrachoffice(selectedBranch.id) */ }
        setEventHandler(0);
    }, [eventHandler]);
    /* ════════════════════════════════════
       FIN LÓGICA ORIGINAL
    ════════════════════════════════════ */

    /* ── tab UI state (nuevo) ── */
    const [activeTab, setActiveTab] = useState('reports');

    /* ══════════════════════════════════
       RENDER
    ══════════════════════════════════ */
    return (
        <>

            <AppShell route="inventory" >
                <MainContent>
                    <div className="inv-page">

                        {/* ── BANNER ── */}
                        <div className="inv-banner">
                            <div className="inv-banner-left">
                                <p className="inv-banner-eyebrow">Gestión</p>
                                <h1 className="inv-banner-title"><IcoBox /> Inventario</h1>
                                <p className="inv-banner-sub">Control de productos, bodegas y movimientos</p>
                            </div>
                            {/* selector sucursal — lógica original intacta */}
                            <ModalBranchofficeSelect actionSelectBranch={actionSelectBranch} />
                        </div>

                        {/* ── TABS NAV ── */}
                        <div className="inv-nav">
                            {TABS.map(t => (
                                <button
                                    key={t.key}
                                    className={`inv-nav-item ${activeTab === t.key ? 'active' : ''}`}
                                    onClick={() => setActiveTab(t.key)}
                                >
                                    {t.icon} {t.label}
                                </button>
                            ))}
                        </div>

                        {/* ── TAB CONTENT ── */}
                        <div className="inv-content">

                            {/* placeholder si no hay sucursal seleccionada */}
                            {!selectedBranch.name && activeTab !== 'reports' && (
                                <div className="inv-no-branch">
                                    <div className="inv-no-branch-icon"><IcoBox /></div>
                                    <p className="inv-no-branch-title">Selecciona una sucursal</p>
                                    <p className="inv-no-branch-sub">Usa el selector de arriba para elegir la sucursal antes de continuar.</p>
                                </div>
                            )}

                            {/* ── Reportes ── */}
                            {activeTab === 'reports' && (
                                <div style={{ animation: 'inv-fade .22s ease both' }}>
                                    <Report
                                        selectedBranch={selectedBranch}
                                        warehouses={warehouses}
                                        setWarehouses={setWarehouses}
                                    />
                                </div>
                            )}

                            {/* ── Recepción de transferencias ── */}
                            {activeTab === 'receive' && selectedBranch.name && (
                                <div style={{ animation: 'inv-fade .22s ease both' }}>
                                    <Reception
                                        selectedBranch={selectedBranch}
                                        warehouses={warehouses}
                                        setWarehouses={setWarehouses}
                                        getWarehouseByBrachoffice={getWarehouseByBrachoffice}
                                    />
                                </div>
                            )}

                            {/* ── Creación de transferencias ── */}
                            {activeTab === 'send' && selectedBranch.name && (
                                <div style={{ animation: 'inv-fade .22s ease both' }}>
                                    <InAndExit
                                        Type="Transfer"
                                        selectedBranch={selectedBranch}
                                        warehouses={warehouses}
                                        setWarehouses={setWarehouses}
                                        groups={groups}
                                        setGroups={setGroups}
                                    />
                                </div>
                            )}

                            {/* ── Recepción inicial de productos ── */}
                            {activeTab === 'in' && selectedBranch.name && (
                                <div style={{ animation: 'inv-fade .22s ease both' }}>
                                    <InAndExit
                                        Type="In"
                                        selectedBranch={selectedBranch}
                                        warehouses={warehouses}
                                        setWarehouses={setWarehouses}
                                        groups={groups}
                                        setGroups={setGroups}
                                    />
                                </div>
                            )}

                            {/* ── Salida de productos ── */}
                            {activeTab === 'out' && selectedBranch.name && (
                                <div style={{ animation: 'inv-fade .22s ease both' }}>
                                    <InAndExit
                                        Type="Exit"
                                        selectedBranch={selectedBranch}
                                        warehouses={warehouses}
                                        setWarehouses={setWarehouses}
                                        groups={groups}
                                        setGroups={setGroups}
                                    />
                                </div>
                            )}

                            {/* ── Bodegas ── */}
                            {activeTab === 'wherehouse' && selectedBranch.name && (
                                <div style={{ animation: 'inv-fade .22s ease both' }}>
                                    <Warehouse
                                        selectedBranch={selectedBranch}
                                        warehouses={ListallWarehouses}
                                        setWarehouses={setWarehouses}
                                        getWarehouseByBrachoffice={getWarehouseByBrachoffice}
                                    />
                                </div>
                            )}

                        </div>

                        {/* ── Importaciones ocultas — referenciadas como variables, NO como JSX ──
            SuccessAlert, ErrorAlert, Transfer, ModalselectList son funciones/utilidades,
            no componentes, por eso no se renderizan con <X /> sino se referencian así: */}
                        <div style={{ display: 'none' }}>
                            <Row><Col sm={12}>
                                <Nav variant="underline">
                                    <li className="nav-sp-item"><Nav.Link eventKey="reports">Reportes</Nav.Link></li>
                                    <li className="nav-sp-item"><Nav.Link eventKey="receive">Recepcion</Nav.Link></li>
                                    <li className="nav-sp-item"><Nav.Link eventKey="send">Creacion</Nav.Link></li>
                                    <li className="nav-sp-item"><Nav.Link eventKey="in">In</Nav.Link></li>
                                    <li className="nav-sp-item"><Nav.Link eventKey="out">Out</Nav.Link></li>
                                    <li className="nav-sp-item"><Nav.Link eventKey="wherehouse">Bodega</Nav.Link></li>
                                </Nav>
                            </Col></Row>
                            <Tabs><Tab eventKey="x" title="x" /></Tabs>
                            <Select options={[]} />
                            <select>{branchList()}</select>
                        </div>
                        {/* referencia de variables para mantener imports sin renderizar como JSX */}
                        {void [SuccessAlert, ErrorAlert, Transfer, ModalselectList, Table,
                            MachinesFetchAPI, PaymentMethodFetchAPI, CategoriesDashFetchAPI]}

                    </div>

                </MainContent>  </AppShell>


            {/* ── Sección comentada original — preservada ── */}
            {/* <section className=''>
        <div className="row justify-content-md-center mt-5">
          <div className="col-12 col-md-12 col-lg-4 m-1 w-100">
            <div className="card-analitics-sp shadow-sm">
              <div className="card-analitics-sp-header d-flex justify-content-between">
                <span>Ingreso de inventario</span>
              </div>
              <span className="card-value-total fw-bold text-color-sp"><i className="uil uil-sign-in-alt"></i> Ingreso</span>
            </div>
          </div>
        </div>
      </section> */}
        </>
    );
};

export default Inventory;